import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '../../system/Paper';
import Page from '../../system/Page';
import ContactUsForm from './ContactUsForm';
import ContactInfo from './ContactInfo';
import colors from '../../../styles/colors';

const contactInfoDetails = {
  icon: 'email',
  label: 'Email',
  info: 'info@bluequbit.io',
};

const ContactUs = () => (
  <Container>
    <Page
      withBackButton
      title="Contact Us"
    >
      <Grid container direction="row" spacing={3}>
        <Grid item md="8" xs="12">
          <Paper>
            <ContactUsForm />
          </Paper>
        </Grid>
        <Grid item md="4" xs="12">
          <Box
            sx={{
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '24px',
              padding: '24px',
            }}
          >
            <Typography variant="h6" sx={{ color: colors.text.primary }}>
              Get in touch
            </Typography>

            <ContactInfo {...contactInfoDetails} />

          </Box>
        </Grid>
      </Grid>
    </Page>
  </Container>
);

export default ContactUs;
